import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMetadataStore } from '@/widgets/Wizard/stores/metadata';
import { useReservationStore } from '@/widgets/Wizard/stores/reservation';

export function usePetsAmenities() {
    const metaDataStore = useMetadataStore();
    const { activeAccount } = storeToRefs(metaDataStore);

    const reservationStore = useReservationStore();
    const { reservedPets } = storeToRefs(reservationStore);

    const amenities = computed<{ id: string }[]>(() => {
        const pets = [];

        if (activeAccount.value && activeAccount.value.options.pets && Object.keys(reservedPets.value).length > 0) {
            let hasPetsAdded = false;

            for (const petId in reservedPets.value) {
                if ((reservedPets.value[petId] ?? 0) > 0) {
                    hasPetsAdded = true;
                    break;
                }
            }

            if (hasPetsAdded && !!activeAccount.value.options.pets.property) {
                pets.push({ id: activeAccount.value.options.pets.property });
            }
        }

        return pets;
    });

    return { amenities };
}
